interface SizeInput {
  width: string | number
  height: string | number
}

function parseSize(size: Partial<SizeInput>) {
  const ratioWidth = typeof size.width === 'string' ? parseInt(size.width, 10) : size.width || 0
  const ratioHeight = typeof size.height === 'string' ? parseInt(size.height, 10) : size.height || 0
  return { width: ratioWidth, height: ratioHeight }
}

export function sizeForRatio(size: Partial<SizeInput>, ratio: SizeInput) {
  const parsedSize = parseSize(size)
  const parsedRatio = parseSize(ratio)
  const width = parsedSize.width || (parsedSize.height * parsedRatio.width) / parsedRatio.height || parsedRatio.width
  const height = parsedSize.height || (parsedSize.width * parsedRatio.height) / parsedRatio.width || parsedRatio.height
  return { width, height }
}
